
export default {
  clients: [],
  fullNameClients: [],
  countClientsHaveInvoice: 0
}
